<template lang="pug">
div
  .md-headline {{ title }}
  // Input row
  md-layout.space-x()
    md-layout
      md-input-container(:class='{ "md-input-invalid": nameError }')
        label Name
        md-input(v-model='newCredit.name', :maxlength='50', @keyup.enter='addCredit')
        span.md-error(v-if='nameError') Name is required
    md-layout
      md-input-container
        label Role
        md-select(v-model='newCredit.role')
          md-option(v-for='role in roles', :key='role.value', :value='role.value') {{ role.label }}
    md-layout.add-btn-container(md-flex='5')
      md-button.md-icon-button.md-primary.md-mini.md-dense(@click='addCredit')
        md-icon(md-iconset="fa fa-plus")
  // Credits list
  md-list.credits-list(v-if='entity.credits && entity.credits.length')
    md-list-item.p-0(v-for='(credit, index) in entity.credits', :key='index')
      .credit-info
        span.credit-name {{ credit.name }}
        span.credit-role {{ getRoleLabel(credit.role) }}
      md-button.md-icon-button.md-primary(@click='removeCredit(index)')
        md-icon(md-iconset="fa fa-trash")
</template>

<script>
export default {
  data() {
    return {
      newCredit: {
        name: '',
        role: 'actor'
      },
      nameError: false,
      roles: [
        { value: 'actor', label: 'Actor' },
        { value: 'director', label: 'Director' },
        { value: 'producer', label: 'Producer' },
        { value: 'screenwriter', label: 'Screenwriter' }
      ]
    };
  },
  props: {
    title: {
      type: String,
      default: 'Credits'
    },
    entity: {
      type: Object,
      required: true
    }
  },
  methods: {
    addCredit() {
      this.nameError = false;
      
      if (!this.newCredit.name || !this.newCredit.name.trim()) {
        this.nameError = true;
        return;
      }

      if (!this.entity.credits) {
        this.$set(this.entity, 'credits', []);
      }

      this.entity.credits.push({
        name: this.newCredit.name.trim(),
        role: this.newCredit.role
      });

      // Reset form
      this.newCredit.name = '';
      this.newCredit.role = 'actor';
    },
    removeCredit(index) {
      this.entity.credits.splice(index, 1);
    },
    getRoleLabel(roleValue) {
      const role = this.roles.find(r => r.value === roleValue);
      return role ? role.label : roleValue;
    }
  }
};
</script>

<style lang="scss" scoped>

.add-btn-container {
  display: flex;
  align-items: center;
  justify-content: center;
  padding-top: 12px;
}

.space-x > *:not(:first-child):not(:last-child) {
  margin-right: 0.5rem;
  margin-left: 0.5rem;
}

.credits-list {
  margin-top: 16px;
  max-height: 200px;
  overflow-y: auto;
  
  .md-list-item {
    display: flex;
    justify-content: space-between;
    align-items: center;
    border-bottom: 1px solid rgba(0, 0, 0, 0.12);
  }

  .credit-info {
    display: flex;
    flex-direction: column;
    flex: 1;
  }

  .credit-name {
    font-weight: 500;
    font-size: 14px;
  }

  .credit-role {
    font-size: 12px;
    color: #757575;
    text-transform: capitalize;
  }
}
</style>




// WEBPACK FOOTER //
// src/shared-components/forms/CreditsForm.vue